import { createStyles, Theme } from "@material-ui/core";
export const ContentOwnersStyle = (theme: Theme) =>
  createStyles({
    tableHeading: {
      height: 36,
    },
    dialogHeight: {
      //maxHeight: 296
    },
    dialogActions:{
      padding: '15px 0'
    },
    infoIconImgHide:{
      '& $.CustomInfoIcon':{
        '& img':{
          display: 'none'
        }
      }
      
    },
    disabledSection: {
      opacity: 0.5,
      pointerEvents: "none",
    },
    greyText: {
      color: "#999",
    },
    mtb30:{
      margin: '30px 0 20px',
      textAlign: 'center'
    },
    font16:{
      fontSize: 16,
      marginBottom: 10,
    },
    placeholderFont: {
      "&>:first-child": {
        "&>:first-child": {
          "& .Font14": {
            fontSize: 14,
          },
        },
      },
    },
    testOwnerdialog: {
      width: "100%",
      padding: "26px 20px 0 40px",
      overflow: "visible",
      minWidth: 750,
    },
    testOwnerdialogFooter: {
      margin: "10px 0",
      padding: "14px 25px 10px",
    },
    pdTop6: {
      paddingTop: 12,
    },
    mb25: {
      marginBottom: 25,
    },
    transitionCSS: {
      "&>:last-child": {
        "& .searchTransition": {
          "& .optionContainer": {
            left: 0,
            width: "100%",
            bottom: 64,
          },
          "&>:nth-child(2)": {
            "&:after": {
              top: -73,
              transform: "rotate(44deg)!important",
            },
          },
        },
        "& .calenderTransition": {
          "&>:first-child": {
            width: '100%!important',
            "& .rdrCalendarWrapper": {
              border: "1px solid #ddd",
              boxShadow: "1px 1px 1px #ddd",
              background: "#fff",
              borderRadius: 4,
              bottom: "46px!important",
              top: "initial!important",
            },
          },
        },
      },
    },
    whiteCard: {
      background: "#FFF",
      boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
      borderRadius: 4,
      padding: "16px 20px",
      marginBottom: 20,
      "& ::placeholder": {
        color: "#999",
        fontWeight: "normal",
        fontSize: 14,
        opacity: 1,
        fontFamily: '"Nunito", sans-serif',
      },
    },
    "& ::placeholder": {
      color: "#999",
      fontWeight: "normal",
      fontSize: 14,
      fontFamily: '"Nunito", sans-serif',
    },
    mainHeading: {
      fontWeight: 600,
      fontSize: 20,
      color: "#333",
      marginBottom: 10,
    },
    mainContainer: {
      border: "1px solid #DFDFDF",
      borderRadius: 4,
      width: "100%",
      position: "relative",
      padding: "16px 9px",
      marginBottom: 42,
    },
    containerHeading: {
      position: "absolute",
      left: 27,
      top: "-17px",
      padding: 2,
      backgroundColor: "#fff",
      fontWeight: 600,
      fontSize: 20,
      color: "#666",
    },
    marginTop16: {
      marginTop: 16,
    },
    plr27: {
      padding: "20px 27px",
    },
    paddingB15: {
      paddingBottom: 15,
    },
    AddMore: {
      color: "#1d7dea",
      cursor: "pointer",
      marginTop: 18,
      fontWeight: 600,
      fontSize: 16,
      marginLeft: "53px",
      display: "inline-block",
      "& img": {
        marginLeft: 6,
        verticalAlign: "middle",
      },
    },
    contentTable: {
      "& thead": {
        "& tr": {
          "&>:first-child": {
            border: 0,
            width: 20,
            padding: 10,
          },
          "&>:nth-child(4), &>:nth-child(5)": {
            width: 275,
            paddingRight: 0,
          },
          "&>:nth-child(2)": {
            width: 100,
          },
          "&>:last-child": {
            width: 200,
            paddingRight: 5,
          },
          "&>:nth-child(3)": {
            width: 40,
          },
          "& th": {
            fontSize: 12,
            color: "#333",
            padding: " 0 10px",
          },
        },
      },
      "& tbody": {
        "& tr": {
          "&>:first-child": {
            border: 0,
            paddingTop: 15,
          },
          // '&>:last-child':{
          //   border: 0,
          //   width: 20,
          // },
          "& td": {
            border: "1px solid #dfdfdf",
            padding: "4px 10px 4px",
            verticalAlign: "top",
          },
          "&>:last-child": {
            padding: 5,
          },
          "& input, & div, & select": {
            border: 0,
            backgroundColor: "transparent",
            marginBottom: 0,
            padding: 0,
          },
          "& select": {
            border: 0,
            backgroundColor: "transparent",
            marginBottom: 0,
            padding: '0 12px',
          },
          "&>:nth-child(4),&>:nth-child(5)": {
            "&>:first-child": {
              "&>:first-child": {
                width: "100%",
                display: "block",
                "&>:first-child": {
                  lineHeight: "23px",
                  "&>:first-child": {
                    width: "86%",
                    display: "inline-block",
                  },
                },
              },
            },
          },
        },
      },
      "& input": {
        height: 40,
        padding: 2,
        width: "100%",
        "&:focus": {
          outline: "none",
          border: "none",
        },
      },
      "& textarea": {
        backgroundColor: "transparent",
        maxHeight: 95,
        overflow: 'auto',
        padding: 0,
        "&::-webkit-scrollbar": {
          display: "none",
        },
      },
    },
    heightMax: {
      display: "inline-block",
      maxHeight: 95,
    },
    mtminus10: {
      marginTop: "-10px",
    },
    
    
    // Test Owner
    OwnerTable: {
      "& thead": {
        "& tr": {
          "&>:nth-child(3)": {
            width: 310,
          },
          "&>:nth-child(2)": {
            width: 60,
          },
          "& th": {
            fontSize: 12,
            color: "#333",
            padding: " 0 16px",
          },
        },
      },
      "& tbody": {
        "& tr": {
          "& td": {
            padding: "4px 10px 0px",
            border: "1px solid #dfdfdf",
            verticalAlign: "top",
            "&> :first-child": {
              // paddingTop: 5,
            },
          },
           "&>:last-child": {
            padding: 5,
          },
          "& input, & div, & select": {
            border: 0,
            backgroundColor: "transparent",
            marginBottom: 0,
            padding: 0,
            width: "100%",
            marginTop: 0,
          },
          "& select": {
            backgroundColor: "transparent",
            marginBottom: 0,
            padding: 12,
            marginTop: 5,
          },
          "&>:nth-child(3)": {
            width: 330,
            height: 95,
            "&>:first-child": {
              "&>:first-child": {
                "&>:first-child": {
                  maxWidth: 300,
                  display: "inline-block",
                  lineHeight: "24px",
                  padding: "6px 28px 6px 3px ",
                },
              },
            },
          },
        },
      },
      "& input": {
        paddingTop: "5px!important",
        width: "100%",
        "&:focus": {
          outline: "none",
          border: "none",
        },
      },
      "& textarea": {
        backgroundColor: "transparent",
        maxHeight: 95,
        overflow: 'auto',
        padding: 0,
        "&::-webkit-scrollbar": {
          display: "none",
        },
      },
    },
    scrollHide: {
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
    maxWidth80per: {
      maxWidth: "80%",
      display: "inline-block",
    },
    manageLineHeight: {
      "&>:first-child": {
        "&>:first-child": {
          "&>:first-child": {
            "& .lineHeight28": {
              lineHeight: "28px",
            },
          },
        },
      },
    },
    addAuthor: {
      "&>:first-child": {
        "&>:nth-child(3)": {
          "&:hover": {
            backgroundColor: "transparent!important",
          },
          "&:focus": {
            backgroundColor: "transparent!important",
          },
        },
      },
    },
    hideDefaultScroll: {
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
    dropDownInput: {
      paddingTop: "10px!important",
      "&>:first-child": {
        "&>:first-child": {
          "&:hover": {
            "&::before": {
              borderBottom: "0!important",
            },
          },
          "&::before": {
            borderBottom: 0,
          },
          "&::after": {
            borderBottom: 0,
          },
        },
      },
    },
    // End
    addPointer: {
      cursor: "pointer",
      padding: 10,
      display: "inline-block",
      marginTop: 0,
      "& img": {
        cursor: "pointer",
      },
    },
    dialogContainer: {
      minWidth: "700px",
      width: "100%",
      maxWidth: "800px",
      maxHeight: '250px'
    },
    searchContainer: {
      position: "relative",
      marginBottom: "20px",
      width: "100%",
      "& .optionContainer": {
        left: 0,
        width: "100%",
        bottom: 64,
      },
      "&>:nth-child(2)": {
        "&:after": {
          top: -73,
          transform: "rotate(44deg)!important",
        },
      },
      "&>img": {
        position: "absolute",
        left: "10px",
        top: "8px",
        width: "20px",
        marginRight: "10px",
      },
      "& input": {
        // border: '0.5px solid #DFDFDF',
        borderRadius: "4px",
        // padding: '10px 10px 10px 40px',
        width: "100%",
      },
    },
    iconContainer: {
      width: "40px",
      height: "40px",
      border: "1px solid #eee",
      borderRadius: "50%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      padding: '0 10px',
      margin: '0 5px'
    },
    dialogHeading:{
      fontSize: 20,
      fontWeight: 600,
      color: '#333',
      display: 'block',
      marginBottom: 10,
    },
    dialogSubHeading:{
      fontSize: 16,
      fontWeight: 400,
      color: '#999',
      lineHeight: '24px'
    },
    normalHeading:{
      fontSize: 16,
      color: '#333',
      fontWeight: 600,
    },
    normalText:{
      fontSize: 16,
      color: '#333',
      fontWeight: 400,
    },
    borderTop:{
      borderTop: '1px solid #ddd',
      width: '100%',
      backgroundColor: '#ddd',
      margin: '20px 0',
    },
    inputContainer: {
      display: "flex",
      alignItems: "center",
      "& input": {
        width: "100%",
        maxWidth: "60px",
        height: "40px",
        // border: "1px solid #eee",
        borderRadius: "4px",
        textAlign: "center",
        margin: "0 15px",
      },
    },
    // selectCustom:{
    //   '& select':{
    //     height: '26px'
    //   }
    // },
    mt5:{
      marginTop: 5
    },
    // Calendar
    customCalendar2:{
      '&>:nth-child(2)':{
        width: '100%!important'
      },
      '& .rdrCalendarWrapper':{
        width: 'auto'
      },
      '& input':{
        paddingRight: 0
      }
    },
    customCalendar:{
      // '&>:first-child':{
      //   '&>:nth-child(2)':{
      //     border: "1px solid #ddd",
      //     boxShadow: "1px 1px 1px #ddd",
      //     background: "#fff",
      //     borderRadius:4,
      //     top: '72px!important',
      //   }
      // }
      '&>:first-child':{
        width: '100%!important'
      },
      '& .rdrCalendarWrapper':{
        width: 'auto'
      },
      '& input':{
        paddingRight: 0
      }
    },
    // Calendar for modal
    customCalendar1: {
      width: '100%',
      "&>:first-child": {
        "&>:nth-child(2)": {
          border: "1px solid #ddd",
          boxShadow: "1px 1px 1px #ddd",
          background: "#fff",
          borderRadius: 4,
          top: "42px!important",
        },
      },
    },
    //create Owner Detail
    contentOwnerDeadlineTable: {
      "& thead": {
        "& tr": {
          "&>:first-child": {
            border: 0,
            width: 20,
            padding: 10,
          },
          "&>:nth-child(4)": {
            width: 399,
          },
          "&>:nth-child(5)": {
            width: 241,
          },
          "&>:nth-child(2)": {
            width: 100,
          },
          "&>:nth-child(3)": {
            width: 132,
          },
          "& th": {
            fontSize: 12,
            color: "#333",
            padding: " 0 16px",
          },
        },
      },
      "& tbody": {
        "& tr": {
          "&>:first-child": {
            border: 0,
          },
          // '&>:last-child':{
          //   border: 0,
          //   width: 20,
          // },
          "& td": {
            padding: "0 10px",
            border: "1px solid #dfdfdf",
            color: "#666",
          },
          "& input, & div, & select": {
            border: 0,
            backgroundColor: "transparent",
            marginBottom: 0,
            padding: 0,
          },
          "& select": {
            border: 0,
            backgroundColor: "transparent",
            marginBottom: 0,
            padding: 12,
          },
          "&>:nth-child(4),&>:nth-child(5)": {
            "&>:first-child": {
              lineHeight: "40px",
            },
          },
        },
      },
      "& input": {
        height: 40,
        padding: 2,
        width: "100%",
        "&:focus": {
          outline: "none",
          border: "none",
        },
      },
      "& textarea": {
        backgroundColor: "transparent",
        maxHeight: 95,
        overflow: 'auto',
        padding: 0,
        "&::-webkit-scrollbar": {
          display: "none",
        },
      },
    },
    
    // End
    maxHeight100: {
      maxHeight: 100,
    },
    rightText: {
      fontSize: 16,
      color: "#666",
      marginLeft: 30,
      "& span": {
        fontWeight: 600,
      },
    },
    secondContainer: {
      marginTop: 32,
    },
    deadline: {
      border: "1px solid #DFDFDF",
      borderRadius: 4,
      marginTop: 16,
      padding: 16,
    },
    border0: {
      border: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
    },
    subHeading: {
      fontWeight: "bold",
      fontSize: 20,
      color: "#666",
    },
    subText: {
      fontWeight: 400,
      fontSize: 16,
      color: "#666",
      "& span": {
        color: "#333",
        fontWeight: 700,
      },
    },
    mb15: {
      marginBottom: "15px!important",
    },
    mainText: {
      fontSize: 16,
      color: "#666",
      fontWeight: 400,
      "& span": {
        fontWeight: "bold",
        marginLeft: 4,
        color: "#666",
      },
    },
    borderR8: {
      borderRadius: 8,
      "& .activeTab": {
        color: "#1d7dea",
      },
    },
    borderBottom: {
      borderBottom: "#CECECE 1px solid",
      paddingBottom: 12,
    },
    inputLable: {
      fontSize: 14,
      color: "#333",
      marginBottom: 10,
      borderBottom: "#CECECE 1px solid",
      paddingBottom: 10,
      display: 'inline-block',
    },
    additionalDesc: {
      backgroundColor: "#FAFAFA",
      padding: 12,
      fontSize: 14,
      fontWeight: 400,
      color: "#666",
      borderRadius: 4,
      marginTop: 32,
      "& span": {
        fontWeight: 600,
        color: "#333",
      },
      '& p':{
        fontWeight: 'bold',
      }
    },
    //content author popup
    AuthorHeading: {
      fontWeight: 600,
      fontSize: 20,
      color: "#333",
    },
    AuthorSubHeading: {
      fontSize: 16,
      color: "#999",
      fontWeight: 400,
      textTransform: "initial",
    },
    popupLabel: {
      fontSize: 14,
      color: "#333",
      marginBottom: 6,
    },
    HeadingMainContainer: {
      justifyContent: "flex-start",
    },
    tabContainer: {
      padding: "12px 0",
      borderBottom: "0.5px solid rgb(210 210 210)",
      paddingBottom: 6,
      margin: "0px 12px",
    },
    fontBold: {
      fontWeight: 600,
      color: "#666",
      marginRight: 5,
    },
    grayFont: {
      color: "#666",
      fontWeight: "normal",
    },
    posRelative: {
      position: "relative",
      "& input[type=number]::-webkit-inner-spin-button, & input[type='number'].mod::-moz-inner-spin-button, & input[type=number]::-webkit-outer-spin-button, & input[type='number'].mod::-moz-outer-spin-button": {
        opacity: 0
      },
      "& input[type=number]":{
          '-moz-appearance': 'textfield',
          'appearance': 'none',
      },
    },
    arrowIcon: {
      position: "absolute",
      right: "8px",
      zIndex: 99,
      top: "1px",
    },
    arrowIconT: {
      cursor: "pointer",
    },
    arrowIconB: {
      marginTop: "-6px",
      cursor: "pointer",
    },
    manageInputHeight:{
      '&>:first-child':{
        marginBottom: '0!important',
        '&>:first-child':{
          height: 40,
        }
      }
    },
    // borderShow:{
    //   border: '1px solid #dfdfdf !important',
    // }
  });
